import { FormDefinition, Lead } from '../api/interfaces'
import { Box, Stack, Step, StepButton, StepButtonProps, StepLabel, Stepper } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface StepperLayoutProps {
    lead: Lead
    form: FormDefinition
}

const StyledStepButton: React.FC<StepButtonProps> = ({ onClick, children }) => (
    <StepButton onClick={onClick}>
        <StepLabel sx={{ '& .MuiStepLabel-label.Mui-completed': { color: 'primary.main' } }}>
            {children}
        </StepLabel>
    </StepButton>
)

export const StepperLayout = ({ lead, form }: StepperLayoutProps) => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    const steps = form.steps.map(
        (item) =>
            <Step key={item.component}>
                {location.pathname === '/Success'
                    ? <StepLabel>
                        {t(item.component + '.stepper.label')}
                    </StepLabel>
                    : <StyledStepButton onClick={e => navigate(item.component)}>
                        {t(item.component + '.stepper.label')}
                    </StyledStepButton>
                }
            </Step>
    )

    const currentStep = () => {
        if (location.pathname === '/Agreements') {
            return form.steps.length
        }
        if (location.pathname === '/Success') {
            return form.steps.length + 1
        }
        return form.steps.reduce((previousValue, currentValue, currentIndex) => {
            return '/' + currentValue.component === location.pathname ? currentIndex : previousValue
        }, 0)
    }

    return <>
        <Stack direction="row" mt={4} spacing={4}>
            <Box sx={{ width: '250px' }}
                 display={{ xs: 'none', sm: 'inline' }}
            >
                <Stepper activeStep={currentStep()}
                         orientation="vertical">
                    {steps}
                    <Step key="Agreements">
                        <StepLabel>
                            {t('Agreements.stepper.label')}
                        </StepLabel>
                    </Step>
                </Stepper>
            </Box>
            <Box sx={{ maxWidth: '700px', width: '100%' }}>
                <Outlet/>
            </Box>
        </Stack>
    </>
}
